/**
 * Spotify Pixel
 * 基础脚本只加载一次；各事件由页面数据或真实用户动作触发，并用本地记录避免重复。
 */
(function () {
  var CONFIG_ID = 'spotify-pixel-config';
  var SCRIPT_ID = 'spdt-capture';
  var SCRIPT_SRC = 'https://pixel.byspotify.com/ping.min.js';
  var STORAGE_PREFIX = 'spdt:';

  var config = readConfig();
  if (!config || !config.key) return;

  install(config.key);
  window.spdt('view');

  if (config.page === 'checkout') {
    trackCheckoutPage(config.checkout || {});
    return;
  }

  trackProduct(config.product);
  trackLead();
  trackSignup(config);
  watchAddToCart(config.currency);
})();

function readConfig() {
  var node = document.getElementById(CONFIG_ID);
  if (!node) return null;
  try {
    return JSON.parse(node.textContent);
  } catch (error) {
    return null;
  }
}

function install(key) {
  window.spdt =
    window.spdt ||
    function () {
      (window.spdt.q = window.spdt.q || []).push(arguments);
    };

  if (!document.getElementById(SCRIPT_ID)) {
    var script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.async = true;
    script.src = SCRIPT_SRC;
    var first = document.getElementsByTagName('script')[0];
    first.parentNode.insertBefore(script, first);
  }

  window.spdt('conf', { key: key });
}

function track(eventName, cents, currency) {
  var value = toMajor(cents);
  if (value === null || !currency) return;
  window.spdt(eventName, {
    value: value,
    currency: currency
  });
}

function toMajor(cents) {
  var amount = Number(cents);
  if (!isFinite(amount)) return null;
  return Math.round(amount) / 100;
}

function remember(storage, key) {
  var name = STORAGE_PREFIX + key;
  try {
    if (storage.getItem(name)) return false;
    storage.setItem(name, '1');
    return true;
  } catch (error) {
    return true;
  }
}

function forget(key) {
  try {
    sessionStorage.removeItem(STORAGE_PREFIX + key);
  } catch (error) {}
}

function trackProduct(product) {
  if (!product) return;
  track('product', product.value, product.currency);
}

function trackCheckoutPage(checkout) {
  var page = window.Shopify && Shopify.Checkout ? Shopify.Checkout.page : '';
  var isPurchase = checkout.orderId || page === 'thank_you';

  if (isPurchase) {
    var orderKey = checkout.orderId || checkout.token;
    if (orderKey && remember(localStorage, 'purchase:' + orderKey)) {
      track('purchase', checkout.total, checkout.currency);
    }
    return;
  }

  if (checkout.token && remember(sessionStorage, 'checkout:' + checkout.token)) {
    track('checkout', checkout.total, checkout.currency);
  }
}

function watchAddToCart(currency) {
  if (!currency) return;

  var nativeOpen = XMLHttpRequest.prototype.open;
  var nativeSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this._spdtMethod = method;
    this._spdtUrl = url;
    return nativeOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    if (isCartAdd(this._spdtMethod, this._spdtUrl)) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) {
          track('addtocart', lineCents(parseJson(this.responseText)), currency);
        }
      });
    }
    return nativeSend.apply(this, arguments);
  };

  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = (init && init.method) || (input && input.method) || 'GET';
      return nativeFetch.apply(this, arguments).then(function (response) {
        if (isCartAdd(method, url) && response.ok) {
          response
            .clone()
            .json()
            .then(function (data) {
              track('addtocart', lineCents(data), currency);
            })
            .catch(function () {});
        }
        return response;
      });
    };
  }
}

function isCartAdd(method, url) {
  return /post/i.test(method || '') && /\/cart\/add(\.js)?(\?|$)/.test(String(url || ''));
}

function lineCents(data) {
  if (!data) return null;
  if (data.items && data.items.length) {
    return data.items.reduce(function (sum, item) {
      if (item.final_line_price != null) return sum + Number(item.final_line_price);
      return sum + Number(item.price || 0) * Number(item.quantity || 1);
    }, 0);
  }
  if (data.final_line_price != null) return data.final_line_price;
  if (data.line_price != null) return data.line_price;
  if (data.price != null) return Number(data.price) * Number(data.quantity || 1);
  return null;
}

function parseJson(text) {
  try {
    return JSON.parse(text);
  } catch (error) {
    return null;
  }
}

function trackLead() {
  if (!document.querySelector('form .form-success, form .note.form-success')) return;
  if (remember(sessionStorage, 'lead:' + location.pathname)) {
    track('lead', 0, readConfig().currency);
  }
}

function trackSignup(config) {
  var registerForm = document.getElementById('create_customer');
  if (registerForm) {
    if (document.querySelector('#create_customer .errors, #create_customer .form-error')) {
      forget('signup:pending');
    }
    registerForm.addEventListener('submit', function () {
      try {
        sessionStorage.setItem(STORAGE_PREFIX + 'signup:pending', '1');
      } catch (error) {}
    });
  }

  if (config.pageType === 'customers/account' && config.customerId) {
    try {
      if (sessionStorage.getItem(STORAGE_PREFIX + 'signup:pending') !== '1') return;
    } catch (error) {
      return;
    }
    forget('signup:pending');
    if (remember(localStorage, 'signup:' + config.customerId)) {
      track('signup', 0, config.currency);
    }
  }
}
